import React, { useRef } from 'react'
import gql from 'graphql-tag'
import get from 'lodash/get'
import { useTranslation } from 'react-i18next'
import { validateIp } from 'helpers/validators'
import { Checkbox, Select, Text } from 'components/forms'
import { StyledPmsForm } from '../styled'
import listApaleoProperties from 'gql/query/listApaleoProperties'

const Pms = ({ formData, updateItem }) => {
	const [t] = useTranslation()
	const queryRef = useRef()

	const validateForPmsPort = value => {
		const val = Number(value)
		const error = t('validators.the_value_must_be_between', { minVal: 0, maxVal: 65535 })
		if(isNaN(val)) {
			return error
		}
		if(val < 0 || val > 65535) {
			return error
		}
		return null
	}

	const pmsOptions = [
		{ label: 'Disabled', value: 'disabled' },
		{ label: 'Protel', value: 'protel' },
		{ label: 'Apaleo', value: 'apaleo' }
	]

	return(
		<StyledPmsForm
			smartSubmit
			initialValues={formData}
			onSubmit={updateItem}
		>
			{({ formState }) => (
				<>
					<Select
						field='parameters.pmsType'
						label={t('options_section.fields.pms_type')}
						options={pmsOptions}
					/>
					{formState.values.parameters?.pmsType === 'protel' &&
						<>
							<Text
								field='parameters.pmsProtelIP'
								label={t('options_section.fields.ip_address')}
								validate={validateIp(t)}
								validateOnChange
								className='textAlignRight'
							/>
							<Text
								field='parameters.pmsProtelPort'
								label={t('options_section.fields.port')}
								validate={validateForPmsPort}
								validateOnChange
								className='textAlignRight'
							/>
						</>
					}
					{formState.values.parameters?.pmsType === 'apaleo' &&
						<Select
							field='parameters.apaleoPmsProperty'
							label={t('options_section.fields.apaleo_pms_property')}
							remoteOptions={{ query: listApaleoProperties, fetchPolicy: 'cache-and-network', ref: queryRef }}
							valueField='id'
							labelField='name'
							error={get(queryRef, 'current.error.graphQLErrors.0.message')}
						/>
					}
					<Checkbox field='parameters.nonGuestTransfer' label={t('options_section.fields.non_guest_transfer')} />
					<Checkbox field='parameters.pmsAutoPrintBills' label={t('options_section.fields.auto_receipt_always')} />
				</>
			)}
		</StyledPmsForm>
	)
}

export default Pms
